import { useMemo } from 'react';
import { useMe, useSession } from '@/features/auth/session-context';
import { useDirectory } from '@/features/messaging/api';
import type { RegisterKind, RegisterRecord } from '@/features/registers/api';
import type { StaffNames } from './register-format';

/** Staff names for staff-type fields: branch directory plus the signed-in user. */
export function useStaffNames(): {
  names: StaffNames;
  options: { value: string; label: string }[];
} {
  const me = useMe();
  const { hasPermission } = useSession();
  const dir = useDirectory(hasPermission('team_messages:read'));
  return useMemo(() => {
    const people = [
      { id: me.id, fullName: me.fullName },
      ...(dir.data?.staff ?? []),
    ];
    return {
      names: new Map(people.map((p) => [p.id, p.fullName])),
      options: people.map((p) => ({ value: p.id, label: p.fullName })),
    };
  }, [me.id, me.fullName, dir.data]);
}

/** Actions of a kind that can be taken on a record in its current status. */
export function actionsFor(k: RegisterKind, r: RegisterRecord) {
  return k.actions.filter((a) => a.allowed && a.from.includes(r.status));
}
